import ptBrTranslations from './pt-br';
import esArTranslations from './es-ar';
import esMxTranslations from './es-mx';
import esCoTranslations from './es-co';
import esPeTranslations from './es-pe';

export default {
    'pt-BR': ptBrTranslations,
    'es-AR': esArTranslations,
    'es-MX': esMxTranslations,
    'es-CO': esCoTranslations,
    'es-PE': esPeTranslations,
};
